// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum ProgressContents {
	Home = 0,
	UsersAndRoles = 1,
	Alerts = 2,
	Notifications = 3,
	Teams = 4,
	ChatTools = 5,
	Integrations = 6,
	AutomateAlertAndIncidentResponse = 7,
	Incidents = 8,
	Heartbeats = 9,
	Find = 10,
	DeprecatedOnes = 11,
}

export interface ProgressState {
	activeTask?: number | null;
	activeContent: ProgressContents;
	latestContent: ProgressContents;
	isOpen: boolean;
}
